var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col justify-center items-center",staticStyle:{"color":"rgba(255, 255, 255, 0.38)"}},[_c('BaseIcon',{staticClass:"animate-bounce fa-3x",attrs:{"name":"futbol"}}),_c('div',{staticClass:"animate-bounce-opacity bg-black w-6 h-1 rounded-full filter blur-sm"}),_c('p',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }